import { useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { store, persistor } from './app/store/store';
import MainRouter from './app/router/MainRouter';
import i18n from './i18n';
import usePageNavigation from './hooks/usePageNavigation';
import CustomErrorFallback from './ui/CustomErrorFallback';
import VerifyCompatibility from './hooks/VerifyCompatibility';

const VERSION = import.meta.env.VITE_BUILD_VERSION;
// console.log(VERSION);

function App() {
  const language = useSelector((state) => state.checking.language);

  const { navigateNextPage } = usePageNavigation();

  useEffect(() => {
    fetch(`/version.json?v=${VERSION}`)
      .then((res) => res.json())
      .then(({ version }) => {
        const storedVersion = localStorage.getItem('app_version');
        console.log('storedVersion');
        if (version !== storedVersion) {
          localStorage.setItem('app_version', version);

          // Navega programáticamente
          navigateNextPage('');

          // Si realmente necesitas recargar
          setTimeout(() => window.location.reload(true), 100);
        }
      })
      .catch((err) => console.error('Error verificando la versión:', err));
  }, []);

  useEffect(() => {
    // Recupera el idioma al cargar la app
    i18n.changeLanguage(language.toLowerCase());
  }, [language]);

  return <MainRouter />;
}

// Envuelve la app con Redux Provider y PersistGate
function RootApp() {
  return (
    // <Sentry.ErrorBoundary fallback={<p>Ocurrió un error inesperado.</p>}>
    <Sentry.ErrorBoundary
      fallback={({ error, eventId, resetError }) => (
        <CustomErrorFallback error={error} eventId={eventId} resetError={resetError} />
      )}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <VerifyCompatibility />
          <App />
        </PersistGate>
      </Provider>
    </Sentry.ErrorBoundary>
    // <Provider store={store}>
    //   <PersistGate loading={null} persistor={persistor}>
    //     <App />
    //   </PersistGate>
    // </Provider>
  );
}

export default RootApp;
